import { createRouter, createWebHistory } from 'vue-router'
import { isTokenValid } from './services/auth.js'

const routes = [
  { path: '/',      name: 'scenario-call', component: () => import('./views/ScenarioCall.vue') },
  { path: '/login', name: 'login',         component: () => import('./views/Login.vue') },
  // старые views (Dashboard/ActiveCall/History/SessionView/Settings) выключены:
  // Co-pilot теперь = голосовое AI-демо. Файлы оставлены на случай отката.
  { path: '/:catchAll(.*)', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Auth guard: требуем валидный токен, кроме /login
router.beforeEach((to) => {
  if (to.name === 'login') return true
  if (!isTokenValid()) return { name: 'login' }
  return true
})

export default router
